function trimTrailingSlash(value: string): string {
  return value.trim().replace(/\/+$/, "");
}

function getRuntimeConfigValue(key: "VITE_AGENT_WS_BASE_URL" | "VITE_API_BASE_URL"): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  const configured = window.__RELANCE_RUNTIME_CONFIG__?.[key];
  if (typeof configured !== "string" || configured.trim().length === 0) {
    return null;
  }

  return trimTrailingSlash(configured);
}

function getBuildTimeConfigValue(
  key: "VITE_AGENT_WS_BASE_URL" | "VITE_API_BASE_URL"
): string | null {
  const configured = import.meta.env[key];
  if (typeof configured !== "string" || configured.trim().length === 0) {
    return null;
  }

  return trimTrailingSlash(configured);
}

export function getApiBaseUrl(): string {
  return (
    getRuntimeConfigValue("VITE_API_BASE_URL") ?? getBuildTimeConfigValue("VITE_API_BASE_URL") ?? ""
  );
}

export function resolveApiUrl(path: string): string {
  const baseUrl = getApiBaseUrl();
  return baseUrl.length > 0 ? `${baseUrl}${path}` : path;
}

export function getAgentWsBaseUrl(): string {
  const configured =
    getRuntimeConfigValue("VITE_AGENT_WS_BASE_URL") ??
    getBuildTimeConfigValue("VITE_AGENT_WS_BASE_URL");
  if (configured) {
    return configured;
  }

  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.hostname}:8081`;
}
